import { render, staticRenderFns } from "./SharedNews.vue?vue&type=template&id=003aa0bc&scoped=true"
import script from "./SharedNews.vue?vue&type=script&lang=js"
export * from "./SharedNews.vue?vue&type=script&lang=js"
import style0 from "./SharedNews.vue?vue&type=style&index=0&id=003aa0bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003aa0bc",
  null
  
)

export default component.exports